// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
  width: 20%;
  padding: 10px;
  margin: 10px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.input-width{
width:90%
}
button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-input {
  width: 20%;
}

.search-button {
  width: 10%;
}

.table-container {
  overflow-x: auto;
  max-height: 300px; /* Adjust the height as needed */
  overflow-y: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
  text-align: left;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  border-radius: 4px;
}

.close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  right: 20px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
}

.text-width-helper {
  visibility: hidden;
  white-space: nowrap;
  position: absolute;
}
.search-icon {
  background-color: #286090;
  color: white;
  height: 45px;
  width: 55px;
  padding: 0px;
  border-radius: 5px;
  cursor: pointer;
}
.text-box{
  width:30%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/look-up/lookup.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;AACA;AACA;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,OAAO;EACP,MAAM;EACN,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,SAAS;AACX","sourcesContent":["input {\n  width: 20%;\n  padding: 10px;\n  margin: 10px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\nbutton {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.input-width{\nwidth:90%\n}\nbutton:hover {\n  background-color: #0056b3;\n}\n\nbutton:disabled {\n  background-color: grey;\n  cursor: not-allowed;\n}\n\n.search-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.search-input {\n  width: 20%;\n}\n\n.search-button {\n  width: 10%;\n}\n\n.table-container {\n  overflow-x: auto;\n  max-height: 300px; /* Adjust the height as needed */\n  overflow-y: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\nth {\n  background-color: #f2f2f2;\n  text-align: left;\n}\n\n.modal {\n  display: none;\n  position: fixed;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n  border-radius: 4px;\n}\n\n.close {\n  color: #aaa;\n  font-size: 28px;\n  font-weight: bold;\n  position: absolute;\n  right: 20px;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n}\n\n.text-width-helper {\n  visibility: hidden;\n  white-space: nowrap;\n  position: absolute;\n}\n.search-icon {\n  background-color: #286090;\n  color: white;\n  height: 45px;\n  width: 55px;\n  padding: 0px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.text-box{\n  width:30%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
